module.exports = __webpack_public_path__ + "img/mark.ad096dd7.svg";